/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_2_1Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_2_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_2_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The required refresh or script actually completes the real task.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_2_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_2_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所需刷新或脚本能够实际完成任务。`)
};

/**
* | output |
* | --- |
* | "The required refresh or script actually completes the real task." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_2_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_2_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_2_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_2_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_2_1(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_2_1(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_2_1 as "gc.search_guides.gridcraft_vs_excel.sections.5.table.rows.2.1" }